export const isLoginPage = () => /^.*\/login(?:&.*)?$/.test(document.location.href);
